import React, { useMemo, useCallback, useReducer } from 'react'

export const SortableContext = React.createContext()

const initialState = {}

const sortDefaults = {
  name: 'sort',
  itemId: null,
  parentId: 0,
  index: 0
}

const SET = 'SET'
const REMOVE = 'REMOVE'

function reducer (state, action) {
  switch (action.type) {
    case SET:
      return {
        ...state,
        [action.payload.name]: {
          ...sortDefaults,
          ...action.payload
        }
      }
    case REMOVE: {
      if (!state[action.payload.name]) return state

      const newState = {
        ...state
      }
      delete newState[action.payload.name]

      return newState
    }
    default: return state
  }
}

export function SortableProvider ({
  children
}) {
  const [sortable, dispatch] = useReducer(reducer, initialState)

  const setSortable = useCallback(
    ({ name, itemId, parentId, index, onSortEnd }) => dispatch({
      type: SET,
      payload: {
        name,
        itemId,
        parentId,
        index,
        onSortEnd
      }
    }),
    []
  )

  const removeSortable = useCallback(
    (name) => dispatch({
      type: REMOVE,
      payload: {
        name
      }
    }),
    []
  )

  const value = useMemo(() => ({
    sortable,
    setSortable,
    removeSortable
  }), [sortable, setSortable, removeSortable])

  return (
    <SortableContext.Provider value={value}>
      {children}
    </SortableContext.Provider>
  )
}

export default SortableProvider
